import { render, staticRenderFns } from "./mvToOldPopup.vue?vue&type=template&id=3011926c"
import script from "./mvToOldPopup.vue?vue&type=script&lang=js"
export * from "./mvToOldPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports